import React from 'react';
import { X } from 'lucide-react';
import { Threshold } from '../../types/payout';

interface ThresholdTableProps {
  thresholds: Threshold[];
  setThresholds: (thresholds: Threshold[]) => void;
}

export function ThresholdTable({ thresholds, setThresholds }: ThresholdTableProps) {
  const addThreshold = () => {
    setThresholds([...thresholds, { trigger: 1.0, payout: 10 }]);
  };

  const removeThreshold = (index: number) => {
    setThresholds(thresholds.filter((_, i) => i !== index));
  };

  const updateThreshold = (index: number, field: keyof Threshold, value: number) => {
    const newThresholds = [...thresholds];
    newThresholds[index] = { ...newThresholds[index], [field]: value };
    setThresholds(newThresholds);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-[var(--secondary-text)] mb-2">
        Thresholds
      </label>
      <table className="data-grid w-full">
        <thead>
          <tr>
            <th>Trigger Level</th>
            <th>Payout (%)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {thresholds.map((threshold, index) => (
            <tr key={index}>
              <td>
                <input
                  type="number"
                  value={threshold.trigger}
                  onChange={(e) => updateThreshold(index, 'trigger', Number(e.target.value))}
                  className="input w-full"
                  step="0.1"
                />
              </td>
              <td>
                <input
                  type="number"
                  value={threshold.payout}
                  onChange={(e) => updateThreshold(index, 'payout', Number(e.target.value))}
                  className="input w-full"
                />
              </td>
              <td>
                <button
                  onClick={() => removeThreshold(index)}
                  className="text-[var(--danger-color)]"
                >
                  <X className="w-4 h-4" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button
        onClick={addThreshold}
        className="btn mt-2"
      >
        Add Threshold
      </button>
    </div>
  );
}